module.exports = __webpack_public_path__ + "static/media/birds_fly_from-window.d166f333.png";